class SubscriptionModelsAppConfig {
    constructor (private SubscriptionModelsAppConstants: SubscriptionModelsAppConstant,
        private $translateProvider: angular.translate.ITranslateProvider,
        private localStorageServiceProvider: angular.local.storage.ILocalStorageServiceProvider,
        private $httpProvider: ng.IHttpProvider, uiSelectConfig: angular.ui.select.ISelectConfig,
        private tmhDynamicLocaleProvider: any) {
        uiSelectConfig.theme = 'bootstrap';
    }
    active = ():void => {
        //Initialize the translation filter provider
        this.$translateProvider.useStaticFilesLoader( { files: [{ prefix: this.SubscriptionModelsAppConstants.i18nRoute, suffix: '.json' }, { prefix: this.SubscriptionModelsAppConstants.generalI18nRoute, suffix: '.json' }] });
        this.$translateProvider.useSanitizeValueStrategy('escaped');
        this.tmhDynamicLocaleProvider.localeLocationPattern(this.SubscriptionModelsAppConstants.localeRoute + '/locale_{{locale}}.js');
        //Initialize the local storage provider
        this.localStorageServiceProvider.setPrefix('ib-subscription-models-app');
        this.localStorageServiceProvider.setStorageType('sessionStorage');
        this.$httpProvider.interceptors.push('IbHttpInterceptor');
        this.$httpProvider.defaults.withCredentials = true;
    };
    $onInit = this.active();
}
SubscriptionModelsAppConfig.$inject = ['SubscriptionModelsAppConstants', '$translateProvider', 'localStorageServiceProvider', '$httpProvider', 'uiSelectConfig', 'tmhDynamicLocaleProvider'];
try {
    angular.module('ib-subscription-models-app').config(SubscriptionModelsAppConfig);
} catch (error) {
    const mod = angular.module('ib-subscription-models-app', []);
    mod.config(SubscriptionModelsAppConfig);
}
